import React, { useEffect } from 'react';
import { ShieldCheck, ArrowLeft } from 'lucide-react';

const AvisoPrivacidad = () => {
    // Asegura que la página empiece desde arriba al cargar
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div style={{ 
            background: '#000000', 
            minHeight: '100vh', 
            display: 'flex', 
            flexDirection: 'column',
            fontFamily: 'sans-serif' // O la fuente que estés usando en el sitio
        }}>
            <main style={{
                flex: 1,
                padding: '80px 7.6923%', // Ajustado para que no necesite el Header
                maxWidth: '1000px',
                margin: '0 auto',
                position: 'relative',
                width: '100%'
            }}>
                {/* Decoración de fondo de rejilla */}
                <div className="grid-pattern" style={{ 
                    position: 'absolute', 
                    top: 0, 
                    left: 0, 
                    right: 0, 
                    bottom: 0, 
                    pointerEvents: 'none', 
                    opacity: 0.2 
                }} />

                <div style={{ position: 'relative', zIndex: 2 }}>
                    {/* Botón opcional para cerrar/regresar de forma elegante */}
                    <button 
                        onClick={() => window.close()} 
                        style={{
                            background: 'transparent',
                            border: 'none',
                            color: 'rgba(255,255,255,0.5)',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px',
                            cursor: 'pointer',
                            marginBottom: '40px',
                            fontSize: '14px',
                            transition: 'color 0.3s'
                        }}
                        onMouseEnter={(e) => e.target.style.color = '#00FFD1'}
                        onMouseLeave={(e) => e.target.style.color = 'rgba(255,255,255,0.5)'}
                    >
                        <ArrowLeft size={16} /> Cerrar Pestaña
                    </button>

                    <div style={{ 
                        display: 'inline-flex', 
                        alignItems: 'center', 
                        gap: '8px', 
                        padding: '8px 16px', 
                        background: 'rgba(0, 255, 209, 0.1)', 
                        marginBottom: '24px',
                        borderLeft: '2px solid #00FFD1'
                    }}>
                        <ShieldCheck size={18} color="#00FFD1" />
                        <span style={{ color: '#00FFD1', fontSize: '14px', fontWeight: 500, letterSpacing: '2px' }}>DOCUMENTO LEGAL</span>
                    </div>

                    <h1 style={{ 
                        fontSize: '42px', 
                        fontWeight: 600, 
                        color: '#FFFFFF', 
                        marginBottom: '40px', 
                        lineHeight: 1.1,
                        letterSpacing: '-1px'
                    }}>
                        Aviso de <span style={{ color: '#00FFD1' }}>Privacidad</span>
                    </h1>

                    <div style={{ 
                        color: 'rgba(255, 255, 255, 0.7)', 
                        lineHeight: '1.8', 
                        fontSize: '16px', 
                        display: 'flex', 
                        flexDirection: 'column', 
                        gap: '32px',
                        textAlign: 'justify'
                    }}>
                        <section>
                            <h2 style={{ color: '#FFFFFF', fontSize: '20px', marginBottom: '12px', fontWeight: '500' }}>1. Identidad y Domicilio del Responsable</h2>
                            <p>PIXELINUX, con operaciones en México, es el responsable del tratamiento de sus datos personales, el cual se realizará con altos estándares de seguridad y confidencialidad técnica.</p>
                        </section>

                        <section>
                            <h2 style={{ color: '#FFFFFF', fontSize: '20px', marginBottom: '12px', fontWeight: '500' }}>2. Datos Personales Recabados</h2>
                            <p>Recabamos datos únicamente para la gestión de servicios tecnológicos y contacto empresarial:</p>
                            <ul style={{ 
                                listStyle: 'none', 
                                paddingLeft: '20px', 
                                borderLeft: '1px solid rgba(0, 255, 209, 0.3)', 
                                marginTop: '15px',
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '10px'
                            }}>
                                <li><span style={{ color: '#00FFD1' }}>//</span> Nombre completo</li>
                                <li><span style={{ color: '#00FFD1' }}>//</span> Correo electrónico corporativo</li>
                                <li><span style={{ color: '#00FFD1' }}>//</span> Identidad de la organización</li>
                                <li><span style={{ color: '#00FFD1' }}>//</span> Requerimientos técnicos específicos</li>
                            </ul>
                        </section>

                        <section style={{ paddingBottom: '60px' }}>
                            <h2 style={{ color: '#FFFFFF', fontSize: '20px', marginBottom: '12px', fontWeight: '500' }}>3. Finalidades del Tratamiento</h2>
                            <p>Sus datos serán cifrados y procesados con el fin de: proveer consultoría especializada en entornos Linux, responder a tickets de soporte, y garantizar la integridad de las comunicaciones cliente-servidor.</p>
                        </section>
                    </div>
                </div>
            </main>
        </div>
    );
};

export default AvisoPrivacidad;
